export default "__VITE_ASSET__83d20877__"